const rePlusgironummer = /^(\d{1,7})-?(\d{1})$/

module.exports = function normalizeSvensktPlusgironummer(input) {
  const match = rePlusgironummer.exec(input.replace(/\s/g, ''))

  if (!match) return input

  const [digits, control] = match.slice(1)

  return `${digits}${control}`
}
